import React, { createContext, useContext, useState, useCallback } from "react";

const MultiExpConfigContext = createContext();

export const useMultiExpConfig = () => useContext(MultiExpConfigContext);

const MultiExpConfigProvider = ({ children }) => {
  const [multiExpConfig, setMultiExpConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [isModelViewerInteractive, setIsModelViewerInteractive] = useState(false);

  const BASE_URL =
    process.env.REACT_APP_CONFIG_API_URL?.trim() ||
    "https://devapi.fiduciaai.in";

  const fetchMultiExpConfig = useCallback(
    async (customerKey, batchId, brandId) => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${BASE_URL}/api/getSpeedShotXConfig`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              customerkey: customerKey,
              batchid: batchId,
              brandid: brandId,
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch SpeedShotX Config");
        }

        const data = await response.json();
        setMultiExpConfig(data);
      } catch (err) {
        console.error("Error fetching MultiExpConfig:", err);
        setError(err.message || "Failed to fetch MultiExpConfig");
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL]
  );

  return (
    <MultiExpConfigContext.Provider
      value={{
        multiExpConfig,
        loading,
        error,
        fetchMultiExpConfig,
        isModelViewerInteractive,
        setIsModelViewerInteractive,
      }}
    >
      {children}
    </MultiExpConfigContext.Provider>
  );
};

export default MultiExpConfigProvider;